module.exports = __webpack_public_path__ + "static/media/locationimage.fc6851f2.svg";